import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';

import { NotificationsRoutingModule } from './notifications-routing.module';
import { NotificationsListComponent } from './pages/notifications-list/notifications-list.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';

import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    NotificationsComponent,
    NotificationsListComponent
  ],
  imports: [
    CommonModule,
    NotificationsRoutingModule,
    MatCardModule,
    MatTableModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatChipsModule,
    SharedModule,
  ],
  exports: [ NotificationsComponent ]
})
export class NotificationsModule { }
